import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JgPhysicalInspUnitFb } from '../models/jg/jg-physical-insp-unit-fb.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class JgPhysicalInspUnitFbService extends RequestService<JgPhysicalInspUnitFb> {
  static PATH = '/jg/physicalInsp/unitFb';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, JgPhysicalInspUnitFbService.PATH, globalService.debugUrl);
  }
}
